// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"9045ddc6","453":"68693753","455":"d0f78a31","704":"3124a1fc","977":"6e17b5c8"}[chunkId] + ".chunk.js";
};